export enum ContactCustomFieldId {
  BirthDate = 360010107399, // text - single line text in Zendesk
  InvoiceAddress = 360010087180, // textarea - multiline text field in Zendesk
  OrderNumber = 360003891500, // integer - integer number field in Zendesk
  VIP = 360013158619, // string field in Zendesk "VIP" / "-"
  CustomShippingCountry = 0,
}
